module.exports = __webpack_public_path__ + "static/media/share_vault.2b81cc84.svg";